import React, { FC, PropsWithChildren, ReactElement } from 'react';
import { Tooltip, Typography } from '@duxton-web/ui';

import './SecondaryText.css';

import { MetadataProps } from '@duxton-web/ui/es/typography/Metadata';

interface OwnProps {
  key?: string;
  showTooltip?: boolean;
}

type SecondaryTextProps = OwnProps & MetadataProps;

export const SecondaryText: FC<PropsWithChildren<SecondaryTextProps>> = ({
  className,
  children,
  showTooltip = true,
  ...others
}) => {
  function renderSecondaryTextContent(): ReactElement {
    return (
      <Typography.Metadata
        className={`grab-x__typography-secondary ${className || ''}`}
        {...others}
      >
        {children}
      </Typography.Metadata>
    );
  }

  function renderSecondaryText(): ReactElement {
    if (!showTooltip) return renderSecondaryTextContent();

    return (
      <Tooltip title={children} placement="leftBottom">
        {renderSecondaryTextContent()}
      </Tooltip>
    );
  }

  return renderSecondaryText();
};
